// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/report-options2/simple-filter/simple-filter-group.component.css
// module id = 470
// module chunks = 0